import { render, staticRenderFns } from "./ShareLinkModal.vue?vue&type=template&id=37a2389c&"
import script from "./ShareLinkModal.vue?vue&type=script&lang=js&"
export * from "./ShareLinkModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports